import { useTranslation } from "react-i18next";
import { useSocialLinks, useCustomSocialLinks } from "@/hooks/content";

export default function SocialMediaSection() {
  const { t } = useTranslation();
  const { record: social } = useSocialLinks();
  const { items: customLinks } = useCustomSocialLinks();

  const socialPlatforms = [
    { name: "Facebook", icon: "ri-facebook-fill", color: "bg-[#1877F2]", link: social.facebook },
    { name: "YouTube", icon: "ri-youtube-fill", color: "bg-[#FF0000]", link: social.youtube },
    { name: "TikTok", icon: "ri-tiktok-fill", color: "bg-foreground-900", link: social.tiktok },
    { name: "Instagram", icon: "ri-instagram-fill", color: "bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF]", link: social.instagram },
    { name: "X/Twitter", icon: "ri-twitter-x-fill", color: "bg-foreground-900", link: social.twitter },
    { name: "WhatsApp", icon: "ri-whatsapp-fill", color: "bg-[#25D366]", link: social.whatsapp },
    ...customLinks.map((l) => ({ name: l.name, icon: l.icon, color: "bg-primary-600", link: l.url })),
  ].filter((p) => p.link && p.link !== "#");

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="ltv-container">
        <div className="text-center mb-8">
          <h2 className="ltv-section-title mb-2">{t("home.connect")}</h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            {t("home.connectDesc")}
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-10">
          {socialPlatforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-2 ${platform.color} text-white px-5 py-3 rounded-md hover:opacity-90 transition-opacity font-medium text-sm whitespace-nowrap`}
            >
              <i className={`${platform.icon} text-lg`}></i>
              <span className="hidden sm:inline">{platform.name}</span>
            </a>
          ))}
        </div>

        {/* Social Media Preview Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {social.youtube && social.youtube !== "#" && (
            <div className="bg-white rounded-lg border border-background-200 p-5 text-center">
              <div className="w-12 h-12 bg-[#FF0000] rounded-lg flex items-center justify-center text-white mx-auto mb-3">
                <i className="ri-youtube-fill text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-1">{t("home.social.youtube")}</h3>
              <p className="text-sm text-foreground-600 mb-3">
                {t("home.social.youtubeDesc")}
              </p>
              <a
                href={social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-semibold text-[#FF0000] hover:underline"
              >
                {t("home.social.youtubeCta")}
              </a>
            </div>
          )}

          {social.facebook && social.facebook !== "#" && (
            <div className="bg-white rounded-lg border border-background-200 p-5 text-center">
              <div className="w-12 h-12 bg-[#1877F2] rounded-lg flex items-center justify-center text-white mx-auto mb-3">
                <i className="ri-facebook-fill text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-1">{t("home.social.facebook")}</h3>
              <p className="text-sm text-foreground-600 mb-3">
                {t("home.social.facebookDesc")}
              </p>
              <a
                href={social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-semibold text-[#1877F2] hover:underline"
              >
                {t("home.social.facebookCta")}
              </a>
            </div>
          )}

          {social.tiktok && social.tiktok !== "#" && (
            <div className="bg-white rounded-lg border border-background-200 p-5 text-center">
              <div className="w-12 h-12 bg-foreground-900 rounded-lg flex items-center justify-center text-white mx-auto mb-3">
                <i className="ri-tiktok-fill text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-1">{t("home.social.tiktok")}</h3>
              <p className="text-sm text-foreground-600 mb-3">
                {t("home.social.tiktokDesc")}
              </p>
              <a
                href={social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-semibold text-foreground-900 hover:underline"
              >
                {t("home.social.tiktokCta")}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}